import { LucideIcon } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export interface CardItem {
  title: string;
  desc: string;
  icon: LucideIcon;
}

interface CardGridProps {
  items: CardItem[];
}

export function CardGrid({ items }: CardGridProps) {
  const getGridCols = () => {
    if (items.length === 1) return "md:grid-cols-1";
    if (items.length === 2) return "md:grid-cols-2";
    return "md:grid-cols-3";
  };

  return (
    <Reveal stagger className={`grid gap-6 ${getGridCols()}`}>
      {items.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.title}
            className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] p-8 transition duration-500 hover:bg-white/[0.05]"
          >
            <Icon className="mb-6 h-8 w-8 text-white/80 transition group-hover:text-accent" />

            <h3 className="display mb-4 text-xl text-white transition group-hover:text-accent">
              {card.title}
            </h3>

            <p className="text-sm leading-relaxed text-white/60">{card.desc}</p>
          </div>
        );
      })}
    </Reveal>
  );
}
